import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b8811530"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "td-progress-circle"
};
const _hoisted_2 = ["viewBox"];
const _hoisted_3 = ["cx", "cy", "r", "stroke-width"];
const _hoisted_4 = ["cx", "cy", "r", "stroke-width", "stroke-linecap"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "td-progress",
    style: _normalizeStyle($options.circleSize)
  }, [$props.type === 'circle' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(), _createElementBlock("svg", {
    viewBox: $options.view,
    class: "td-progress-circle__track"
  }, [_createElementVNode("circle", {
    class: "td-progress-circle__track",
    cx: $options.circleDistance,
    cy: $options.circleDistance,
    r: $options.radius,
    "stroke-width": $props.strokeWidth,
    style: _normalizeStyle({
      stroke: $props.outerColor
    }),
    fill: "none"
  }, null, 12, _hoisted_3), _createElementVNode("circle", {
    class: "td-progress-circle__path",
    cx: $options.circleDistance,
    cy: $options.circleDistance,
    r: $options.radius,
    "stroke-width": $props.strokeWidth,
    "stroke-linecap": $props.linecap,
    style: _normalizeStyle($options.circlePathStyle),
    fill: "none"
  }, null, 12, _hoisted_4)], 8, _hoisted_2))])) : _createCommentVNode("", true)], 4);
}